import React from 'react';
import HomeHeader from '../components/HomeHeader/HomeHeader';
import ApiByBUnit from '../components/Graphics/ApiByBUnit';
import { registerCharts } from '../components/Graphics/registerCharts';
import ApiByProduct from '../components/Graphics/ApiByProduct';
import ApiDeveloperProgram from '../components/Graphics/ApiDeveloperProgram';
import ApiByStructure from '../components/Graphics/ApiByStructure';
import ApiManagedByUser from '../components/Graphics/ApiManagedByUser';
import './home.css';

const Home: React.FC = () => {

    registerCharts();

    return (
        <div className="home-header-container">
            <HomeHeader />
            <div className="home-graphs-container">
                <div className="graph-container">
                <ApiManagedByUser />
                </div>
                <div className="graph-container">
                <ApiByStructure/>
                </div> 
                <div className="graph-container">
                <ApiDeveloperProgram />
                </div>
                <div className="graph-container">
                <ApiByBUnit />
                </div>
                <div className="graph-container">
                <ApiByProduct />
                </div> 
            </div> 
        </div>
    )
}

export default Home;